import React, { useState, useEffect } from 'react';
import Alert from 'react-bootstrap/Alert'
import styles from '../../styles/login.module.css';
import * as LoginCode from '../../scripts/StatusLoginCode';
import * as StatusCode from '../../scripts/StatusCode';
import * as action from '../../actions/login';
import { getHashClient, getInitialConfig } from '../../actions/authentication';
import Select from 'react-select';
import i18n from '../../i18n/i18n';
import ButtonLoad from 'react-bootstrap-button-loader';
import { useCookies } from 'react-cookie';
import * as storage from '../../utils/storage';
import { getConnectionStringNamePrefix } from '../../utils';
import * as cookie from '../../scripts/CookiesAppGo';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { log } from '../../actions/error'
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';

import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrosoft } from '@fortawesome/free-brands-svg-icons';
import { faRightToBracket, faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import { faCircleUser, faLock, faEye, faEyeSlash } from "@fortawesome/pro-duotone-svg-icons";

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'var(--color2)' : 'black',
        backgroundColor: state.isSelected ? 'var(--color1)' : '#FFF'
    }),
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? 'var(--color1)' : 'rgb(195 195 195)',
        boxShadow: state.isFocused ? '0 0 0 1px var(--color1)' : 'none'
    }),
    menuList: (provided, state) => ({
        ...provided,
        padding: '0px',
        maxHeight: '135px'
    })
}

function LoginForm(props) {
    /**
     * useMsal is hook that returns the PublicClientApplication instance,
     * that tells you what msal is currently doing. For more, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
     */
    const { instance } = useMsal();

    const handleSSOLogin = () => {
        instance
            .loginRedirect({
                ...loginRequest,
                prompt: 'create',
            })
            .catch((error) => console.log(error));
    };

    const handleKonekLogin = () => {
        setSelectedLoginKonek(true);
    }

    const handleReturnLogin = () => {
        setSelectedLoginKonek(false);
    }

    const saveListPrefixConnection = (list) => {
        props.saveListPrefixConnection(list);
    }

    const cookieLogin = cookie.login;
    const [isEnabled, setIsEnabled] = useState(false);
    const [errorLogin, setErrorLogin] = useState(false);
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [cookies, setCookie] = useCookies([cookieLogin]);
    const [listConnection, setListConnection] = useState([]);
    const [listPrefixConnection, setListPrefixConnection] = useState([]);
    const [isPrefixActivate, setIsPrefixActivate] = useState(false);
    const [connection, setConnection] = useState('');
    const [isLoginActivate, setIsLoginActivate] = useState(false);
    const [isSSOLoginActivate, setIsSSOLoginActivate] = useState(false);
    const [selectedLoginKonek, setSelectedLoginKonek] = useState(false);
    const [showDivSSO, setShowDivSSO] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [values, setValues] = useState({
        password: '',
        showPassword: false,
        userCode: storage.getUserCode(),
    });
    const [errors, setErrors] = useState({
        usercode: false,
    });

    const { handleErrorLogin, handleMultipleCompanies, handleChangePassword, connect, handleChangeUserCode, handleShowForgotPassword } = props;

    const changeLogo = props.changeParentLogo;

    useEffect(() => {
        getInitialParam();
        handleChangeUserCode(values.userCode);
    }, []);

    useEffect(() => {
        if (listConnection.length > 0) {
            let connection = storage.getConnectionString();

            const connectionExist = listConnection.filter(item => item.value == connection?.value).length > 0;

            if (connection === undefined || connection === '' || !connectionExist) {
                connection = listConnection[0];
            }

            setConnection(connection);
        }
    }, [listConnection]);

    useEffect(() => {
        if (connection !== undefined) {
            storage.saveConnectionString(connection);

            getInitialParam(false);
        }
    }, [connection]);

    useEffect(() => {
        if (isLoginActivate && !isSSOLoginActivate
            || selectedLoginKonek) {
            setShowForm(true);
            handleShowForgotPassword(true);
        } else {
            setShowForm(false);
            handleShowForgotPassword(false);
        }

        if (isSSOLoginActivate && !selectedLoginKonek) {
            setShowDivSSO(true);
        } else {
            setShowDivSSO(false);
        }
    }, [selectedLoginKonek, isLoginActivate, isSSOLoginActivate]);


    const onChangeLanguage = optionSelected => {
        storage.saveLanguage(optionSelected.value);
        i18n.changeLanguage(optionSelected.value);
        changeLogo(optionSelected.value);
        props.handleChangeLanguage(optionSelected.value);
    }

    const onChangeConnection = (connectionSelected) => {
        setConnection(connectionSelected);
    }

    const getCurrentLanguage = () => {
        const lang = storage.getLanguage();

        return lang;
    }

    const saveCookieLogin = () => {
        // Here we save the datetime that the user login successfully
        setCookie(cookieLogin, new Date().toLocaleString(), { path: '/' });
    }

    const getClientHashKey = async (userCode = null, connectionNameValue = null, isPrefixDB = false) => {
        setIsLoading(true);

        const connectionName = connectionNameValue == null ? connection.value : connectionNameValue;

        var response = await getHashClient(userCode, connectionName, isPrefixDB);

        if (response.status !== StatusCode.STATUS_OK) {
            setErrorLogin(true);
            setMessage(i18next.t('login:login.validation.no-clientkey'));
        }
        else {
            setIsEnabled(true);
        }

        setIsLoading(false);
    }

    const getInitialParam = async (isLoadConnections = true) => {
        var response = await getInitialConfig(connection.value);

        if (response.status !== StatusCode.STATUS_OK) {
            setErrorLogin(true);
            setMessage(i18next.t('login:login.validation.no-database'));
        }
        else {
            setIsEnabled(true);
            setIsLoginActivate(response.isLoginActivate);
            setIsSSOLoginActivate(response.isSSOLoginActivate);

            if (isLoadConnections) {
                var list = response.connectionString;

                let connections = [];
                list.forEach(item => {
                    connections.push({ value: item, label: item });
                });

                setListConnection(connections);

                const isActivatePrefix = response.activatePrefix;

                setIsPrefixActivate(isActivatePrefix);

                if (isActivatePrefix) {
                    // This is to be used in the LoginForm
                    setListPrefixConnection(response.prefixConnectionString);

                    // This is to be used in the parent page Login
                    // We need the list of prefix to be used also in Forgot Password, First setup
                    saveListPrefixConnection(response.prefixConnectionString);

                    // This is to be used in the internal pages (already login - ChagePassword)
                    storage.saveListPrefixConnection(response.prefixConnectionString);
                } else {
                    storage.destroyListPrefixConnection();
                }
            }
        }
    }

    const handleChangePass = () => (event) => {
        setValues({ ...values, password: event.target.value });
    };

    const handleChangeUser = () => (event) => {
        setValues({ ...values, userCode: event.target.value });
        handleChangeUserCode(event.target.value);
    };

    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleUserCodeBlur = () => {
        if (values.userCode == undefined || values.userCode === '') {
            setErrors({ ...values, usercode: true });
        } else {
            setErrors({ ...values, usercode: false });
        }
    };

    const handleChangeLanguage = (event) => {
        const language = event.target.checked ? "fr" : "en";

        storage.saveLanguage(language);
        i18n.changeLanguage(language);
        changeLogo(language);
        props.handleChangeLanguage(language);
    }

    const validatePrefixUser = async (userCode) => {
        const connectionName = await getConnectionStringNamePrefix(listPrefixConnection, userCode);

        if (connectionName != null) {
            await getClientHashKey(userCode, connectionName, true);
        } else {
            await getClientHashKey(userCode);
        }

        return connectionName;
    }

    const handleLoginClick = async (e) => {
        e.preventDefault();

        setIsLoading(true);

        const connectionName = await validatePrefixUser(values.userCode);
        const isPrefixDB = connectionName != null;

        storage.destroyCompanies();
        storage.saveUserCode(values.userCode);


        action.loginUser(values.userCode, values.password, connectionName == null ? connection.value : connectionName, isPrefixDB)
            .then(result => {
                switch (result.statusLogin) {
                    case LoginCode.LOGIN_FAILED:
                    case LoginCode.LOGIN_USERLOCKED:
                    case LoginCode.LOGIN_TEMPORARILYUNAVAILABLE:
                    case LoginCode.LOGIN_RESTRICTEDEMPLOYEEHIRED:
                    case LoginCode.LOGIN_PASSWORDFIRSTSETUP:
                        setErrorLogin(true);
                        setMessage(result.errorMessage);
                        setIsLoading(false);
                        handleErrorLogin(result.statusLogin);
                        break;
                    case LoginCode.LOGIN_CHANGEPASSWORD:
                        handleChangePassword(values.userCode);
                        setIsLoading(false);
                        setValues({ ...values, password: '' });
                        break;
                    case LoginCode.LOGIN_MULTIPLECOMPANIES:
                        setIsLoading(false);
                        handleMultipleCompanies(result.companies);
                        break;
                    case LoginCode.LOGIN_INACTIVEPORTAL:
                        setErrorLogin(true);
                        setMessage(result.errorMessage);
                        setIsLoading(false);
                        break;
                    default:
                        setIsLoading(false);
                        connect();
                }
            }).catch((error) => {
                setErrorLogin(true);
                setMessage(i18next.t('errorPage:content.title'));
                setIsLoading(false);
                log(error.message);
            });
    }

    return (
        <form>
            {errorLogin && <Alert variant="danger">
                {message}
            </Alert>
            }
            {showDivSSO &&
                <div className={styles.divButtonSSO}>
                    <Button
                        variant="contained"
                        color="default"
                        className={styles.buttonLogin}
                        startIcon={<FontAwesomeIcon icon={faMicrosoft} />}
                        onClick={handleSSOLogin}
                    >
                        {i18next.t('login:login.form.buttonLoginMicrosoft')}
                    </Button>

                    {isLoginActivate &&
                        <Button
                            variant="contained"
                            color="default"
                            className={`${styles.buttonLogin} ${styles.buttonLoginKonek}`}
                            startIcon={<FontAwesomeIcon icon={faRightToBracket} />}
                            onClick={handleKonekLogin}
                        >
                            {i18next.t('login:login.form.buttonLoginKonek')}
                        </Button>
                    }
                </div>
            }

            {showForm &&
                <div id="divKonekLogin">
                    {isSSOLoginActivate &&
                        <div className={styles.divButtonReturn}>
                            <Button
                                variant="contained"
                                color="default"
                                className={`${styles.buttonLogin} ${styles.buttonReturnLogin}`}
                                startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                                onClick={handleReturnLogin}
                            >
                                {i18next.t('login:login.form.buttonReturnLogin')}
                            </Button>
                        </div>
                    }
                    <TextField
                        className={styles.input}
                        id="usercode"
                        name="usercode"
                        onChange={handleChangeUser()}
                        value={values.userCode}
                        tabIndex={10}
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    {/*<AccountCircle className={styles.icon_usercode} />*/}
                                    <FontAwesomeIcon icon={faCircleUser} className={styles.icon_usercode} />
                                </InputAdornment>
                            ),
                        }}
                    />
                    {errors.usercode && <p className={styles.error}>{i18next.t('login:login.validation.usercode')}</p>}

                    <TextField
                        className={styles.input}
                        id="password"
                        name="password"
                        type={values.showPassword ? 'text' : 'password'}
                        onChange={handleChangePass()}
                        tabIndex={11}
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <FontAwesomeIcon icon={faLock} className={styles.icon_password} />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        className={styles.eyeIcon}
                                    >
                                        <FontAwesomeIcon icon={values.showPassword ? faEye : faEyeSlash} className={styles.icon_passwordVisibility} />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />

                    <div className={styles.divSubmit}>
                        <ButtonLoad tabIndex={15} loading={isLoading} disabled={!isEnabled} type="submit" className={styles.submit} variant="success" onClick={handleLoginClick}>{i18next.t('login:login.form.signin')}</ButtonLoad>
                    </div>
                </div>
            }


            {listConnection.length > 1 && <div><br /><label className={styles.labelDatabase} htmlFor="connection">Database</label>
                <Select
                    value={listConnection.filter(item => item.value == connection)}
                    name="connection"
                    value={connection}
                    className={styles.select}
                    styles={customStyles}
                    options={listConnection}
                    onChange={onChangeConnection}
                    tabIndex={14} /></div>}

            <Typography component="div" style={{ marginTop: '10px' }}>
                <Grid component="label" container alignItems="center" spacing={1}>
                    <Grid item>EN</Grid>
                    <Grid item>
                        <Switch checked={getCurrentLanguage() == "fr"} onChange={handleChangeLanguage} name="language" tabIndex={13} />
                    </Grid>
                    <Grid item>FR</Grid>
                </Grid>
            </Typography>
        </form>
    );
};

export default withNamespaces(['login', 'errorPage'], { wait: true })(LoginForm);